<template>
  <div class="support" :style="{ 'min-height': clientHeight + 'px' }">
    <div class="support-header">
      <div class="header-content">
        <h2 class="title">{{ $t("m.zendesk.title") }}</h2>
      </div>
    </div>

    <div class="support-content" v-if="!sendSucess">
      <article class="support-main">
        <div class="zendesk">
          <div class="zendeskinp name">
            <input
              id="name"
              v-model="name"
              type="text"
              :placeholder="$t(`m.zendesk.name`)"
            />
          </div>
          <div class="zendeskinp email">
            <input
              id="email"
              v-model="email"
              type="text"
              :placeholder="$t(`m.zendesk.email`)"
            />
            <span class="error" v-if="emailNull">{{
              $t("m.zendesk.null")
            }}</span>
            <span class="error" v-if="emailFail">{{
              $t("m.zendesk.fail")
            }}</span>
          </div>
          <div class="zendeskinp drop one">
            <div
              class="dropdown"
              @click="openListOne()"
              :style="{ height: listHeightOne + 'px' }"
            >
              <input
                id="select"
                readonly
                :class="{ noWord: currentIndexTwo == 20 }"
                v-model="qusetOne"
                :placeholder="this.$i18n.t(`m.zendesk.qsO`)"
              />
              <ul class="dropdown-menu">
                <li
                  v-for="(item, index) in optionOne"
                  :key="index"
                  :class="{
                    active: currentIndexOne === index,
                    up: listHeightOne < 240,
                  }"
                  @click="qsOClick(index)"
                >
                  {{ item }}
                </li>
              </ul>
            </div>
            <span class="error" v-if="qONull">{{ $t("m.zendesk.null") }}</span>
          </div>
          <div class="zendeskinp drop">
            <div
              class="dropdown"
              @click="openListTwo()"
              :style="{ height: listHeightTwo + 'px' }"
            >
              <input
                id="select"
                readonly
                :class="{ noWord: currentIndexTwo == 20 }"
                v-model="qusetTwo"
                :placeholder="this.$i18n.t(`m.zendesk.qsT`)"
              />
              <!-- {{ qusetTwo }} -->

              <ul class="dropdown-menu">
                <li
                  v-for="(item, index) in optionTwo"
                  :key="index"
                  :class="{
                    active: currentIndexTwo === index,
                    up: listHeightTwo < 180,
                  }"
                  @click="qsTClick(index)"
                >
                  {{ item }}
                </li>
              </ul>
            </div>
            <span class="error" v-if="qTNull">{{ $t("m.zendesk.null") }}</span>
          </div>
          <div class="zendeskinp dec">
            <textarea
              id="dec"
              rows="5"
              v-model="dec"
              :placeholder="$t(`m.zendesk.dec`)"
            ></textarea>
          </div>
          <div class="submit">
            <a class="btnSub" v-if="!subActive" @click="postZendesk()">{{
              $t("m.zendesk.sub")
            }}</a>
            <a class="btnSubActive" v-if="subActive">{{
              $t("m.zendesk.sub")
            }}</a>
            <!-- <input id="attachment" type="file" @change="hFileChange" />
            <span @click="sendLog()">xxxx</span>
            <span @click="test()">测试</span> -->
          </div>
        </div>
      </article>
      <Freq></Freq>
    </div>
    <div class="support-content" v-if="sendSucess">
      <p class="successPageP">{{ $t("m.zendesk.restitle") }}</p>
      <div class="line"></div>
      <span class="res-container" v-html="$t(`m.zendesk.container`)"> </span>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Freq from "../components/Freq.vue";

export default {
  components: { Freq },
  data() {
    return {
      clientHeight: "",
      email: "",
      name: "",
      qusetOne: "",
      qusetTwo: "",
      dec: "",
      listHeightOne: "30",
      listHeightTwo: "30",
      listLineUl: false,
      optionOne: [
        "Oculus Quest 1",
        "Oculus Quest 2",
        "Oculus Quest 3",
        "Oculus Rift / Rift S",
        "Valve Index",
        "HP Reverb G2",
        "Others",
      ],
      optionTwo: [
        "No File Access",
        "Video Playback Issue",
        "App Crash",
        "Version Update Issue",
        "Others",
      ],
      currentIndexOne: 20,
      currentIndexTwo: 20,
      sendSucess: false,
      emailNull: false, //邮箱为空
      emailFail: false, //邮箱格式不对
      qONull: false, //问题一为空

      qTNull: false, //以此类推

      Freq: [],
      subActive: false,
      base64URL: "",
      blob: "",
      file_content: "",
      file_name: "",
      zendesk_token: "",
      file: "",
    };
  },
  mounted() {
    this.freq();
    // 获取浏览器可视区域高度
    this.clientHeight = `${document.documentElement.clientHeight}` - 104;
    document.addEventListener("click", (e) => {
      let selOne = document.querySelectorAll("#select")[0];
      let selTwo = document.querySelectorAll("#select")[1];
      if (this.listHeightOne == 240) {
        if (e.target != selOne) {
          this.openListOne();
          this.listLineUl = false; //点击其他区域关闭
        }
      }
      if (this.listHeightTwo == 180) {
        if (e.target != selTwo) {
          this.openListTwo();
          this.listLineUl = false; //点击其他区域关闭
        }
      }
    });
  },
  methods: {
    // hFileChange(e) {
    //   console.log(e);
    //   this.files = e.target.files[0];
    //   if (this.files.length === 0) {
    //     return;
    //   }
    //   this.file_name = this.files.name;
    //   var file = document.querySelector("#attachment").files[0];
    //   const reader = new FileReader();
    //   reader.onload = () => {
    //     // when the reader is done, the content is in reader.result.
    //     console.log("result", reader.result);
    //     this.file_content = reader.result;
    //   };
    //   reader.readAsBinaryString(file);
    //   console.log(file);
    //   this.file = file;
    // },
    // async sendLog() {
    //   console.log(this.file);
    //   await this.$http({
    //     url: "https://skyboxvr.zendesk.com/api/v2/uploads.json",
    //     method: "POST",
    //     // processData: false,
    //     headers: {
    //       Authorization:
    //         "Bearer a77f8583fe07cc99ce0f5c0d073712e83e4b52c82d866ffdc35babf2ff93d331",
    //       "Content-Type": "application/binary",
    //     },
    //     params: {
    //       filename: this.file_name,
    //     },
    //     data: this.file,
    //   })
    //     .then((res) => {
    //       console.log(res);
    //       this.zendesk_token = res.data.upload.token;
    //       console.log(this.zendesk_token);
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     });
    // },
    // async test() {
    //   await this.$http({
    //     url: "https://skyboxvr.zendesk.com/api/v2/tickets.json",
    //     method: "POST",
    //     headers: {
    //       Authorization:
    //         "Bearer a77f8583fe07cc99ce0f5c0d073712e83e4b52c82d866ffdc35babf2ff93d331",
    //       "content-type": "application/json",
    //     },
    //     data: {
    //       ticket: {
    //         requester: {
    //           name: "测试内容",
    //           email: "msint.wang@sourcetech.xyz",
    //         },
    //         // comment: {
    //         //   uploads: this.zendesk_token,
    //         // },
    //         description: "测试内容",
    //         subject: "Website Support Ticket",
    //       },
    //     },
    //   }).then((res) => {
    //     console.log(res);
    //   });
    // },
    async freq() {
      await this.$http({
        url: "https://64qx6jnt0a.execute-api.cn-north-1.amazonaws.com.cn/Prod/",
        method: "POST",
        data: {
          methods: "freq",
          lang: "en",
        },
      }).then((res) => {
        this.Freq = res.data.Items;
        this.load = false;
      });
    },
    qsOClick(index) {
      this.currentIndexOne = index;

      this.qusetOne = this.optionOne[index];
    },
    qsTClick(index) {
      this.currentIndexTwo = index;

      this.qusetTwo = this.optionTwo[index];
    },
    openListOne() {
      if (this.listHeightOne < 240) {
        this.listHeightOne = 240;
      } else {
        this.listHeightOne = 30;
      }
    },
    openListTwo() {
      if (this.listHeightTwo < 180) {
        this.listHeightTwo = 180;
      } else {
        this.listHeightTwo = 30;
      }
    },
    async postZendesk() {
      var reg = /^[0-9a-zA-Z_.-]+[@][0-9a-zA-Z_.-]+([.][a-zA-Z]+){1,2}$/;
      let num = 0;
      if (this.email == "") {
        document.querySelector(".email").className = "zendeskinp email error";
        this.emailNull = true;
        this.emailFail = false;
      } else if (!reg.test(this.email)) {
        document.querySelector(".email").className = "zendeskinp email error";

        this.emailFail = true;
        this.emailNull = false;
      } else {
        document.querySelector(".email").className = "zendeskinp email";
        this.emailNull = false;
        this.emailFail = false;
        num++;
      }

      if (this.qusetOne == "") {
        document.querySelectorAll(".dropdown")[0].style.border =
          "2px solid rgba(245, 49, 0, 0.878)";
        this.qONull = true;
      } else {
        document.querySelectorAll(".dropdown")[0].style.border =
          "2px solid rgba(192, 192, 192, 0.377)";
        this.qONull = false;
        num++;
      }
      if (this.qusetTwo == "") {
        document.querySelectorAll(".dropdown")[1].style.border =
          "2px solid rgba(245, 49, 0, 0.878)";
        this.qTNull = true;
      } else {
        document.querySelectorAll(".dropdown")[1].style.border =
          "2px solid rgba(192, 192, 192, 0.377)";
        this.qTNull = false;
        num++;
      }

      const zendeskDate = {
        methods: "zendesk",
        email: this.email,
        name: this.name,
        dec:
          "Which VR device do you use?: " +
          this.qusetOne +
          "\n\n" +
          "Select an issue type:" +
          this.qusetTwo +
          "\n\n" +
          "Description" +
          "\n\n" +
          this.dec,
      };
      if (num == 3 && this.subActive == false) {
        this.subActive = true;
        await this.$http({
          method: "POST",
          url: "https://p3cqfbor0b.execute-api.us-west-2.amazonaws.com/Prod/",
          data: zendeskDate,
        })
          .then((res) => {
            this.sendSucess = !this.sendSucess;
          })
          .catch((err) => {
            alert("The server is busy. Try resubmitting please");
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/zendesk.scss";
</style>
